import React, { useRef } from "react";
import { useState } from "react";
import { toast } from "react-toastify";

import { exampleService } from "../../services/example.service";
import Button from "@mui/material/Button";
import LoadingButton from '@mui/lab/LoadingButton';
import "./AddFile.css"

export default function AddFile(props) {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [number, setNumber] = useState(0);
  const [file_URL, setFile] = useState(null);
  const hiddenFileInput = useRef(null);
  const [isUploading, setIsUploading] = useState(false);


  function handleTitleChange(event) {
    setTitle(event.target.value);
  }

  function handleDescriptionChange(event) {
    setDescription(event.target.value);
  }
  function handleNumberChange(event) {
    setNumber(event.target.value);
  }

  async function handleFileSelect(e) {
    //1. Upload the file through the backend
    setFile(e.target.files[0]);
  }

  async function handleSubmitForm(event) {
    event.preventDefault();
    setIsUploading(true);
    
    const uploadData = new FormData();

    uploadData.append("filename", file_URL);
    try {
      const response = await exampleService.uploadFile(uploadData);
      await exampleService.createFile({
        title,
        description,
        number,
        file_URL: response.data.fileUrl,
      });
      props.handleGetAllPodcasts();
     toast.success("Audio created!");
      setTitle("");
      setDescription("");
      setNumber(0);
      setFile(null);
    } catch (error) {
      const errorDescription = error.response.data.message;
      toast.error(errorDescription)
    }finally {
      setIsUploading(false); // set isUploading back to false to hide the loading spinner
    }
   
  }

  return (
    <div className="App">
      <h1>Add an audio</h1>
      <form onSubmit={handleSubmitForm}>
        <label htmlFor="title">Title</label>
        <input
          id="title"
          type="text"
          value={title}
          onChange={handleTitleChange}
        />
        <label htmlFor="description">Description</label>
        <input
          id="description"
          type="text"
          value={description}
          onChange={handleDescriptionChange}
        />
        <label htmlFor="number">Number</label>
        <input
          id="number"
          type="number"
          value={number}
          onChange={handleNumberChange}
        />
        <label htmlFor="file_URL">File</label>
        <input
          id="file_URL"
          type="file"
          onChange={handleFileSelect}
          ref={hiddenFileInput}
        />
        <Button className="button" variant="contained" type="submit">
        {isUploading ? <LoadingButton loading variant="outlined"></LoadingButton> : "Create File"}
        </Button>
       <br/>
       <br/>
      </form>
    </div>
  );
}


